export const FETCH_SURVEYJS_FORM_DETAILS_START = "FETCH_SURVEYJS_FORM_DETAILS_START";
export const FETCH_SURVEYJS_FORM_DETAILS_SUCCESS = "FETCH_SURVEYJS_FORM_DETAILS_SUCCESS";
export const FETCH_SURVEYJS_FORM_DETAILS_FAILURE = "FETCH_SURVEYJS_FORM_DETAILS_FAILURE";
export const RESET_SURVEYJS_FORM_DATA = "RESET_SURVEYJS_FORM_DATA";
export const FETCH_SURVEYJS_FORM_DETAILS_COMPLETE = "FETCH_SURVEYJS_FORM_DETAILS_COMPLETE";
